import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useProjectContext } from '../contexts/ProjectContext';
import { NotaioForm } from '../components/Notaio/NotaioForm';
import { TaxBreakdown } from '../components/Notaio/TaxBreakdown';
import { calcolaTaxBreakdown } from '../services/taxCalculations';
import type { Notaio as NotaioType } from '../types';

export function Notaio() {
  const { currentProject } = useProjectContext();
  const [notaio] = useState<NotaioType | null>(null);
  const [isLoading] = useState(false);
  const [error] = useState<string | null>(null);

  // TODO: Migrate to REST API
  const handleSave = async (_data: Partial<NotaioType>) => {
    alert('Funzionalita in sviluppo');
  };

  if (!currentProject) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">Seleziona un progetto per visualizzare i costi notaio</p>
      </div>
    );
  }

  const immobile = currentProject?.immobile;
  const prezzoFromImmobile = immobile?.prezzoAcquisto ? parseFloat(immobile.prezzoAcquisto) : 0;

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Calcola breakdown (usa valori default se notaio non esiste)
  const notaioData: NotaioType = notaio || {
    id: '',
    projectId: currentProject.id,
    isPrimaCasa: immobile?.primaCasa ?? true,
    venditoreImpresa: immobile?.venditoreImpresa ?? false,
    percentualeAgenzia: immobile?.percentualeAgenzia ? parseFloat(immobile.percentualeAgenzia) : 3,
    catastale: immobile?.renditaCatastale ? parseFloat(immobile.renditaCatastale) : 0,
    conMutuo: true,
    onorarioCompravendita: 1200,
    onorarioMutuo: 650,
    visureVerifiche: 150,
    bolliDiritti: 230
  };

  const breakdown = calcolaTaxBreakdown(currentProject, notaioData);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Costi Notaio e Tasse</h2>
          <p className="text-gray-600 mt-1">
            Calcolo imposte acquisto e costi notarili
          </p>
        </div>
      </div>

      {!prezzoFromImmobile && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex items-center justify-between">
          <p className="text-amber-800">
            Compila la Scheda Immobile (prezzo acquisto e prima casa) per calcoli accurati
          </p>
          <Link
            to="/immobile"
            className="ml-4 px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors text-sm whitespace-nowrap"
          >
            Vai alla Scheda Immobile
          </Link>
        </div>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-700">{error}</p>
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Form */}
        <div>
          <NotaioForm
            notaio={notaio}
            immobile={immobile}
            prezzoImmobile={prezzoFromImmobile}
            onSave={handleSave}
            isLoading={isLoading}
          />
        </div>

        {/* Breakdown */}
        <div>
          <TaxBreakdown
            breakdown={breakdown}
            isPrimaCasa={notaioData.isPrimaCasa}
            venditoreImpresa={notaioData.venditoreImpresa}
            conMutuo={notaioData.conMutuo}
          />
        </div>
      </div>
    </div>
  );
}
